
import './bootstrap';
import './utilities/scrolltable';

import Vue from "vue";
import BootstrapVue from 'bootstrap-vue'

import 'select2';
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import Vuelidate from 'vuelidate'
import VTooltip from 'v-tooltip'
import { loadProgressBar } from 'axios-progress-bar'
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton);
window.Vue = Vue;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VTooltip)
Vue.component('akg-calculator', require('./views/AkgCalculator.vue'));

let configNotifications = {
    notiflyPIH01: true,
    pihCounter: 0,
    notiflyCodes: true,
    greenPlantNotify: true,
}

let akgConstants = {
    codeKEV : "7-278",
    codeATAD : "7-277",
    codeKNK0 : "7-276",
}

window.akgConstants = akgConstants;

window.configNotifications = configNotifications;

loadProgressBar({
    showSpinner: true,
    trickle: false,
    parent: ".akg-card"
});

import TableSettings from "./components/TableSettings";

var app = new Vue({
    el: '#app',
    components: {
        RingLoader,
        TableSettings,
    },
    data() {
        return {
            loading: true,
            color: '#5dc596',
            size: '80px',
            margin: '2px',
            radius: '100%',
            showTableSettings: false,
            tableSize: 1,
        }
    },
    methods: {
        closeTableSettings() {
            return (this.showTableSettings = false);
        },

        showTableSettingsFunction() {
            return (this.showTableSettings = true);
        },

        updateTableSize(size) {
            $(".table").scroltable('destroy');
            $(".table-scalable").css({
                "-webkit-transform": "scale(" + size + ")",
                "-moz-transform": "scale(" + size + ")",
                "-ms-transform": "scale(" + size + ")",
                "-o-transform": "scale(" + size + ")",
                transform: "scale(" + size + ")"
            });
            $(".table").scroltable();
            this.tableSize = size;
        },
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js